<div class="bg-background min-h-screen flex flex-col items-center justify-center px-4 relative overflow-hidden">
    <!-- Architectural Background Gradients -->
    <div class="absolute top-0 left-0 w-full h-full pointer-events-none opacity-20">
        <div class="absolute top-[-10%] right-[-10%] w-[600px] h-[600px] rounded-full bg-primary-container/30 blur-[120px]"></div>
        <div class="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-secondary-container/20 blur-[120px]"></div>
    </div>

    <!-- Brand Header -->
    <div class="mb-12 relative z-10 text-center">
        <a routerLink="/" class="text-3xl font-extrabold tracking-tight text-primary brand-logo">ZAD ERP</a>
    </div>

    <!-- Main Card -->
    <div class="w-full max-w-[540px] bg-surface-container-lowest rounded-xl p-10 ambient-shadow relative z-10 text-center border border-outline-variant/10">
        <!-- Icon Header -->
        <div class="w-20 h-20 bg-primary-container/20 rounded-2xl flex items-center justify-center mx-auto mb-8">
            <span class="material-symbols-outlined text-4xl text-primary">mark_email_read</span>
        </div>

        <h1 class="text-2xl font-bold text-on-surface mb-4 tracking-tight">Confirm your email</h1>
        
        <p class="text-on-surface-variant leading-relaxed mb-10">
            We've sent a verification link to <br>
            <span class="font-bold text-primary">{{email}}</span>. <br>
            Please check your inbox and click the link to activate your ZAD ERP workspace.
        </p>

        <!-- Secondary Info -->
        <div class="bg-surface-container-low rounded-xl p-6 mb-10 text-sm text-on-surface-variant text-start leading-relaxed border-s-4 border-primary">
            <p><strong>Didn't receive the email?</strong> Check your spam folder or try resending the link. It usually takes less than a minute to arrive.</p>
        </div>

        <!-- Actions -->
        <div class="flex flex-col gap-4">
            <button class="w-full py-4 bg-primary-container text-on-primary font-bold text-lg rounded-xl shadow-lg hover:shadow-primary/20 transition-all active:scale-95">
                Resend Verification Link
            </button>
            
            <div class="mt-4 pt-6 border-t border-outline-variant/15 text-center">
                <a routerLink="/create-account" class="text-primary font-bold hover:underline">
                    Back to Sign Up
                </a>
            </div>
        </div>
    </div>

    <!-- Footer Copyright -->
    <footer class="mt-12 w-full max-w-[540px] text-center">
        <p class="text-xs text-outline font-medium tracking-tight">
            &copy; 2026 ZAD ERP. All rights reserved.
        </p>
    </footer>
</div>
